import { FaLinkedinIn } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="border-t border-slate-800 bg-slate-950 px-6 py-8 text-slate-400 md:px-12 lg:px-14">
      <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
        <div className="text-center md:text-left">
          <p className="text-sm">
            Built by{" "}
            <span className="font-semibold text-cyan-300">
              Gabriel Espinosa
            </span>
          </p>

          <p className="mt-1 text-xs text-slate-500">
            &copy; {new Date().getFullYear()} FullStackGabe. All rights
            reserved.
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-5 text-sm">
          <a
            href="/about"
            className="transition hover:text-cyan-300"
          >
            About
          </a>

          <a
            href="/projects"
            className="transition hover:text-cyan-300"
          >
            Projects
          </a>

          <a
            href="/resume"
            className="transition hover:text-cyan-300"
          >
            Resume
          </a>

          <a
            href="/contact"
            className="transition hover:text-cyan-300"
          >
            Contact
          </a>
        </div>

        <div className="flex items-center gap-3">
          <a
            href="https://www.linkedin.com/in/gabriel-j-80a715188/"
            target="_blank"
            rel="noreferrer"
            className="flex h-9 w-9 items-center justify-center rounded border border-slate-700 text-xs font-semibold text-slate-400 transition hover:border-cyan-400/70 hover:bg-cyan-400/10 hover:text-cyan-300"
            aria-label="LinkedIn"
          >
            <FaLinkedinIn size={16} />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
